import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Text from '#components/a/Text'
import Button from '#components/a/Button'
import Input from '#components/a/form/Input'
import ControlsGroup from '#components/m/ControlsGroup'
import DateRangePicker from '#components/m/DateRangePicker'
import AzubiMultiSelect from '#components/m/Versetzungsplan/AzubiMultiSelect'
import {endOfDay, format, startOfDay} from 'ag-common/facades'
import TerminConflictHint from '#components/m/Versetzungsplan/TerminConflictHint'
import DialogLogic from '../Flyout/DialogLogic'
import {connect} from 'react-redux'

export function AusbilderTerminCreateDialog(props) {
  const [datePicker, setDatePicker] = useState({start: startOfDay(new Date()), end: endOfDay(new Date())})
  const [conflictExists, setConflictExists] = useState({
    ausbilderTerminConflict: false,
    azubiTerminConflict: false,
    gruppenTerminConflict: false,
  })
  const [selectedAzubis, setSelectedAzubis] = useState([])
  const [customTerminTitle, setCustomTerminTitle] = useState('')
  const [termineOfSelectedAzubi, setTermineOfSelectedAzubi] = useState()
  const [azubiSelectIsOpen, setAzubiSelectIsOpen] = useState(false)
  const [azubis, setAzubis] = useState(props.azubis)

  useEffect(() => {
    const selectAll = [{name: i18n.t('termin_select_all_azubis'), id: -1}]
    setAzubis(selectAll.concat(props.azubis))
  }, [props.azubis])

  const onDateRangeChanged = (start, end) => {
    setDatePicker({
      start,
      end,
    })
    checkForConflict(selectedAzubis, start, end)
  }

  const onCustomTitleChanged = text => {
    setCustomTerminTitle(text)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const {toggleView} = props
    const termin = {
      subject: customTerminTitle,
      from: format(datePicker.start, 'yyyy-MM-dd'),
      to: format(datePicker.end, 'yyyy-MM-dd'),
      azubiIds: selectedAzubis.map(azubi => azubi.id),
    }
    await actions.versetzungsplan.createTerminAsAusbilder(termin)
    toggleView()
  }

  const CUSTOM_TERMIN_MAX_LENGTH = 60
  const remainingLetters = CUSTOM_TERMIN_MAX_LENGTH - customTerminTitle.length

  const selectChanged = value => {
    if (value.find(item => item.id === -1)) {
      value = props.azubis
    }
    setSelectedAzubis(value)
    checkForConflict(value, datePicker.start, datePicker.end)
  }

  const checkForConflict = (selectedAzubis, start, end) => {
    let azubisTermine = []
    selectedAzubis.forEach(azubi => {
      const azubiTermine = getTermineFromAzubi(azubi.id)
      azubisTermine = azubisTermine.concat(azubiTermine)
    })
    setTermineOfSelectedAzubi(azubisTermine)
    const conflicts = DialogLogic.doesConflictExistForAusbilder(start, end, azubisTermine)
    setConflictExists(conflicts)
  }

  const getTermineFromAzubi = azubiId => {
    const azubiVersetzungsplan = props.versetzungsplaene.filter(vp => vp.userId === azubiId)
    return azubiVersetzungsplan[0].termine
  }

  return (
    <form onSubmit={handleSubmit} className="terminCreateDialog">
      <div className="textWrapper">
        <Text text={i18n.t('termin_azubis')} />
        {azubiSelectIsOpen && <Text text={i18n.t('termin_close_hint')} modifier="hint" />}
      </div>
      <AzubiMultiSelect
        azubis={azubis}
        selectedAzubis={selectedAzubis}
        handleSelect={selectChanged}
        placeholder={i18n.t('termin_select_azubis')}
        onMenuOpen={() => setAzubiSelectIsOpen(true)}
        onMenuClose={() => setAzubiSelectIsOpen(false)}
      />
      <div>
        <div className="textWrapper">
          <Text text={i18n.t('termin_titel')} />
          <Text text={i18n.t('remaining_letters_hint', [remainingLetters])} modifier="hint" />
        </div>
        <Input
          type="text"
          required
          value={customTerminTitle}
          maxLength={CUSTOM_TERMIN_MAX_LENGTH}
          onChangeHandle={evt => onCustomTitleChanged(evt.target.value)}
        />
      </div>
      <DateRangePicker
        initialStartDate={datePicker.start}
        initialEndDate={datePicker.end}
        onRangeUpdated={onDateRangeChanged}
      />
      <TerminConflictHint conflictExists={conflictExists} />
      <ControlsGroup>
        <Button variant="secondarydark" text={i18n.t('misc_cancel')} event={props.toggleView} />
        <Button
          variant="primarydark"
          text={i18n.t('misc_save')}
          disabled={
            conflictExists.azubiTerminConflict || conflictExists.gruppenTerminConflict || selectedAzubis.length === 0
          }
          type="submit"
        />
      </ControlsGroup>
    </form>
  )
}

function mapStateToProps(state) {
  return {
    versetzungsplaene: state.versetzungsplan.versetzungsplaene,
  }
}

export default connect(mapStateToProps)(AusbilderTerminCreateDialog)

AusbilderTerminCreateDialog.propTypes = {
  toggleView: PropTypes.func,
  azubis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  versetzungsplaene: PropTypes.array,
}
